<!--服务商-->
<template>
  <div>
    <fy_header></fy_header>
    <fy_banner></fy_banner>
    <!--    <fy_container v-for="(item,index) in containerList" :key="index" :container="item"></fy_container>-->
    <fy_tabbar :title="title" :product-list="productList" :extend="[]" :is-service="true" v-on:clickTab="clickTab"></fy_tabbar>
    <fy_footer></fy_footer>
  </div>
</template>

<script>
    import fy_header from "../components/fy_header"
    import fy_banner from "../components/fy_banner"
    import fy_tabbar from "../components/fy_tabbar"
    import fy_container from "../components/fy_container"
    import fy_footer from "../components/fy_footer"

    import productList from "../assets/conf/service"
    import click from "../js/clickTab"

    export default {
        name: "service",
        components: {
            fy_header,
            fy_banner,
            fy_tabbar,
            fy_container,
            fy_footer,
        },
        data() {
            return {
                title: ['FY200云喇叭','FY070打印机'],
                productList,
            }
        },
        mounted() {
            let index = parseInt(this.$cookies.get('serviceTitle') || 0)
            click(index)
        },
        methods: {
            clickTab(index) {
                console.log('服务商监听到' + index)
                this.$cookies.set('serviceTitle',index,'1d','/')
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/service.vue